import { AxiosPromise, AxiosStatic } from "axios";
import { CommitmentHistoryOutput } from "../types/CommitmentHistory";

export const getCommitmentHistory =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (commitmentId: string): AxiosPromise<CommitmentHistoryOutput> =>
    await appAxios.get(`${serverURL}/commitments/${commitmentId}/history`, {
      withCredentials: true,
    });
